export const FETCH_COMMUNITIES = 'FETCH_COMMUNITIES'
export const FETCH_COMMUNITY_CONFIG = 'FETCH_COMMUNITY_CONFIG'
export const UPDATE_CONFIG = 'UPDATE_CONFIG'
export const ADD_CONFIG = 'ADD_CONFIG'
export const DELETE_CONFIG = 'DELETE_CONFIG'
export const TOGGLE_DROPDOWN = 'TOGGLE_DROPDOWN'
export const UPDATE_SEARCH_STRING = 'UPDATE_SEARCH_STRING'
export const UPLOAD_IMAGE = 'UPLOAD_IMAGE'

export const DEFAULT_COMMUNITY_IDENTIFIER = 'newsbrief-defaults'

export const DEFAULT_CONFIG_SOURCE = 'default'
export const SPECIFIC_CONFIG_SOURCE = 'specific'

export const DEFAULT_PARTNER_CODE = 'Default'

export const Keys = {
  HeaderImage: 'brand_header_image_url',
}



// WEBPACK FOOTER //
// ./src/pages/community-config/constants.ts